(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header') || this;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = { top: 0, bottom: 0 };

      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.setHeaderHeight();

      this.mql = window.matchMedia('(max-width: 990px)');
      if (this.mql && this.mql.addEventListener) {
        this.mql.addEventListener('change', this.setHeaderHeight);
      } else if (this.mql && this.mql.addListener) {
        this.mql.addListener(this.setHeaderHeight);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search') || document.querySelector('predictive-search');

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.mql) {
        if (this.mql.removeEventListener) {
          this.mql.removeEventListener('change', this.setHeaderHeight);
        } else if (this.mql.removeListener) {
          this.mql.removeListener(this.setHeaderHeight);
        }
      }
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    createObserver() {
      if (!this.header) return;
      this.observer = new IntersectionObserver((entries) => {
        if (!entries || !entries[0]) return;
        this.headerBounds = entries[0].intersectionRect || { top: 0, bottom: 0 };
      });

      this.observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const headerBottom =
        this.headerBounds && typeof this.headerBounds.bottom === 'number'
          ? this.headerBounds.bottom
          : this.header
          ? this.header.offsetHeight
          : 0;
      const headerTop = this.headerBounds && typeof this.headerBounds.top === 'number' ? this.headerBounds.top : 0;

      if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= headerTop) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.header ? this.header.querySelectorAll('header-menu') : [];
      if (this.disclosures && this.disclosures.forEach) {
        this.disclosures.forEach((disclosure) => {
          try {
            disclosure.close();
          } catch (e) {}
        });
      }
    }

    closeSearchModal() {
      this.searchModal = this.header ? this.header.querySelector('details-modal') : null;
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        try {
          this.searchModal.close(false);
        } catch (e) {}
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Desktop hover menu behavior with resize handling and debounce
  (function () {
    let initDone = false;
    let resizeTimer = null;
    const breakpoint = 990;

    function initHeaderMenus() {
      const isDesktop = window.innerWidth >= breakpoint;
      document.querySelectorAll('header-menu').forEach(function (headerMenu) {
        const details = headerMenu.querySelector('details');
        if (!details) return;

        // Remove existing handlers to prevent duplicates
        headerMenu._mouseenter && headerMenu.removeEventListener('mouseenter', headerMenu._mouseenter);
        headerMenu._mouseleave && headerMenu.removeEventListener('mouseleave', headerMenu._mouseleave);
        if (details._summaryClick) {
          const summary = details.querySelector('summary');
          if (summary) summary.removeEventListener('click', details._summaryClick);
          details._summaryClick = null;
        }

        headerMenu._mouseenter = function () {
          if (window.innerWidth >= breakpoint) details.setAttribute('open', '');
        };
        headerMenu._mouseleave = function () {
          if (window.innerWidth >= breakpoint) details.removeAttribute('open');
        };

        headerMenu.addEventListener('mouseenter', headerMenu._mouseenter);
        headerMenu.addEventListener('mouseleave', headerMenu._mouseleave);

        // Prevent summary click on desktop
        const summary = details.querySelector('summary');
        if (summary) {
          details._summaryClick = function (e) {
            if (window.innerWidth >= breakpoint) {
              e.preventDefault();
            }
          };
          summary.addEventListener('click', details._summaryClick);
        }

        // Close details if resizing to mobile
        if (!isDesktop) {
          details.removeAttribute('open');
        }
      });
      initDone = true;
    }

    function onResizeDebounced() {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initHeaderMenus();
        resizeTimer = null;
      }, 150);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeaderMenus);
    } else {
      initHeaderMenus();
    }

    window.addEventListener('resize', onResizeDebounced);
  })();

  } catch(e) { console.error(e); }
})();
})();
